import { Page } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import { theme } from 'lib/theme';
import * as React from 'react';
import { PageHeader } from 'components/PageHeader';

export const PageUnknown: React.FC = () => {
  return (
    <Page header={<PageHeader title="Unknown Page" showSidebarButton />}>
      <PageEmpty
        subtext="This page does not exist"
        iconCircled={false}
        style={{ backgroundColor: theme.colors.background }}
      />
    </Page>
  );
};
